/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type LogoutSisenseUserInput = {
    sisenseUserId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type LogoutSisenseUserMutationVariables = {
    input: LogoutSisenseUserInput;
};
export type LogoutSisenseUserMutationResponse = {
    readonly logoutSisenseUser: {
        readonly success: boolean | null;
    } | null;
};
export type LogoutSisenseUserMutation = {
    readonly response: LogoutSisenseUserMutationResponse;
    readonly variables: LogoutSisenseUserMutationVariables;
};



/*
mutation LogoutSisenseUserMutation(
  $input: LogoutSisenseUserInput!
) {
  logoutSisenseUser(input: $input) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogoutSisenseUserInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LogoutSisenseUserPayload",
    "kind": "LinkedField",
    "name": "logoutSisenseUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LogoutSisenseUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LogoutSisenseUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "LogoutSisenseUserMutation",
    "operationKind": "mutation",
    "text": "mutation LogoutSisenseUserMutation(\n  $input: LogoutSisenseUserInput!\n) {\n  logoutSisenseUser(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f6cf14eceb953a651f830b8cbc9965c2';
export default node;
